import { z } from 'zod';

export const idParamSchema = z.object({
  id: z.string().transform(s => Number(s)),
});

export const licenseIdParamSchema = z.object({
  licenseId: z.string().transform(s => Number(s)),
});

export const seriesIdParamSchema = z.object({
  seriesId: z.string().transform(s => Number(s)),
});

export const roundIdParamSchema = z.object({
  roundId: z.string().transform(s => Number(s)),
});

export const divisionIdParamSchema = z.object({
  divisionId: z.string().transform(s => Number(s)),
});

export const teamIdParamSchema = z.object({
  teamId: z.string().transform(s => Number(s)),
});

export const registrationIdParamSchema = z.object({
  registrationId: z.string().transform(s => Number(s)),
});

export const tokenSchema = z.object({
  token: z.string(),
});
